import PageSkeleton from './PageSkeleton';
import HeaderSkeleton from './HeaderSkeleton';
import { StepperSkeleton } from '../../../core/Stepper';
import DetailFormSkeleton from './DetailFormSkeleton';
import SalarySkeleton from './SalarySkeleton';
import ApprovalReviewersSkeleton from './ApprovalReviewersSkeleton';
import Shimmer from '../../../core/Shimmer/Shimmer';
import ShimmerWrapper from '../../../core/Shimmer/ShimmerWrapper';
import CompanyFormSkeleton from './CompanyFormSkeleton';
import FormSkeleton from './FormSkeleton';
import StyleThemeSkeleton from './StyleThemeSkeleton';
import EvaluationSkeleton from './EvaluationSkeleton';
import ApplicationFormBuilderSkeleton from './ApplicationFormBuilderSkeleton';
import RecruitmentFlowSkeleton from './RecruitmentFlowSkeleton';
import JobAdPreviewContainerSkeleton from './JobAdPreviewContainerSkeleton';
import { AutomationActionEditorSkeleton, AutomationSkeleton } from './AutomationSkeleton/index';

export const Skeletons = {
    PageSkeleton,
    HeaderSkeleton,
    StepperSkeleton,
    DetailFormSkeleton,
    SalarySkeleton,
    CompanyFormSkeleton,
    FormSkeleton,
    ApplicationFormBuilderSkeleton,
    EvaluationSkeleton,
    StyleThemeSkeleton,
    RecruitmentFlowSkeleton,
    JobAdPreviewContainerSkeleton,
    AutomationActionEditorSkeleton,
    AutomationSkeleton,
};


const Skeleton = ({ type = 'form', show = true, ...rest }) => {
    if (!show) return null;
    switch (type) {
        case 'page':
            return <PageSkeleton  {...rest} />;
        case 'header':
            return <HeaderSkeleton {...rest} />;
        case 'job_name_form':
            return <HeaderSkeleton.HeaderTitleSkeleton {...rest} />;
        case 'header_actions':
            return <HeaderSkeleton.HeaderActionSkeleton {...rest} />;
        case 'job_language_form':
            return <HeaderSkeleton.HeaderDropdownSkeleton {...rest} />;
        case 'close_button':
            return <HeaderSkeleton.HeaderDropdownSkeleton {...rest} />;
        case 'tabs':
            return <StepperSkeleton labelLines={2} {...rest} />;
        case 'detail-form':
        case 'basic_form':
        case 'custom_job_form':
            return <DetailFormSkeleton {...rest} />;
        case 'job_business_unit_form':
            return <FormSkeleton.FieldSkeleton {...rest} />;
        case 'salary_info':
            return <SalarySkeleton {...rest} />;
        case 'company-form':
            return <CompanyFormSkeleton {...rest} />;
        case 'form':
            return <FormSkeleton.BaseFormSkeleton {...rest} />;
        case 'dropdown':
        case 'application_form_selection':
            return <FormSkeleton.DropdownSkeleton {...rest} />;
        case 'ckeditor':
        case 'external_job_ad':
            return <FormSkeleton.CKEditorSkeleton {...rest} />;
        case 'textarea':
        case 'internal_note':
            return <FormSkeleton.TextareaSkeleton {...rest} />;
        case 'checkbox':
            return <FormSkeleton.CheckboxSkeleton {...rest} />;
        case 'radio':
            return <FormSkeleton.RadioButtonSkeleton {...rest} />;
        case 'field':
        case 'notepads':
            return <FormSkeleton.FieldSkeleton {...rest} />;
        case 'field-group':
            return <FormSkeleton.FieldGroupSkeleton {...rest} />;
        case 'title':
            return <FormSkeleton.Title {...rest} />;
        case 'collaborators':
            return <FormSkeleton.FieldGroupSkeleton columns={1} fields={3} {...rest} />;
        case 'approval_reviewers':
            return <ApprovalReviewersSkeleton {...rest} />;
        // Header action: one select (~220x38) sitting in the section title, not a form.
        case 'approval_process':
            return (
                <ShimmerWrapper direction="row" align="center" justify="flex-end">
                    <Shimmer width={220} height={38} radius={6} />
                </ShimmerWrapper>
            );
        case 'style_theme':
            return <StyleThemeSkeleton {...rest} />;
        case 'evaluation':
            return <EvaluationSkeleton {...rest} />;
        case 'application_form_builder':
            return <ApplicationFormBuilderSkeleton {...rest} />;
        case 'application_form_preview':
            return <ApplicationFormBuilderSkeleton.Preview {...rest} />;
        case 'recruitment_flow':
            return <RecruitmentFlowSkeleton {...rest} />;
        case 'job_ad_preview':
            return <JobAdPreviewContainerSkeleton {...rest} />;
        case 'automation_action_editor':
            return <AutomationActionEditorSkeleton {...rest} />;
        default:
            return <FormSkeleton.BaseFormSkeleton {...rest} />;
    }
};


Skeleton.TYPES = {
    PAGE: 'page',
    HEADER: 'header',
    JOB_NAME_FORM: 'job_name_form',
    HEADER_ACTIONS: 'header_actions',
    JOB_LANGUAGE_FORM: 'job_language_form',
    CLOSE_BUTTON: 'close_button',
    TABS: 'tabs',
    DETAIL_FORM: 'detail-form',
    BASIC_FORM: 'basic_form',
    CUSTOM_JOB_FORM: 'custom_job_form',
    JOB_BUSINESS_UNIT_FORM: 'job_business_unit_form',
    SALARY_INFO: 'salary_info',
    COMPANY_FORM: 'company-form',
    FORM: 'form',
    DROPDOWN: 'dropdown',
    APPLICATION_FORM_SELECTION: 'application_form_selection',
    CKEDITOR: 'ckeditor',
    EXTERNAL_JOB_AD: 'external_job_ad',
    TEXTAREA: 'textarea',
    INTERNAL_NOTE: 'internal_note',
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    FIELD: 'field',
    NOTEPADS: 'notepads',
    FIELD_GROUP: 'field-group',
    TITLE: 'title',
    COLLABORATORS: 'collaborators',
    APPROVAL_REVIEWERS: 'approval_reviewers',
    APPROVAL_PROCESS: 'approval_process',
    STYLE_THEME: 'style_theme',
    EVALUATION: 'evaluation',
    APPLICATION_FORM_BUILDER: 'application_form_builder',
    APPLICATION_FORM_PREVIEW: 'application_form_preview',
    RECRUITMENT_FLOW: 'recruitment_flow',
    JOB_AD_PREVIEW: 'job_ad_preview',
    AUTOMATION_ACTION_EDITOR: 'automation_action_editor',
};

export default Skeleton;